import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FaHome, FaExclamationTriangle } from 'react-icons/fa';

const NotFound = ({ darkMode }) => {
    const { t } = useTranslation();

    return (
        <div className={`flex flex-col items-center justify-center min-h-screen ${
            darkMode ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'
        }`}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className={`text-center p-8 rounded-lg shadow-xl max-w-lg ${
                    darkMode ? 'bg-gray-800' : 'bg-white'
                }`}
            >
                <FaExclamationTriangle className={`text-6xl mb-6 mx-auto ${
                    darkMode ? 'text-cyan-400' : 'text-cyan-600'
                }`} />

                <h1 className="text-4xl font-bold mb-4">404</h1>
                <h2 className={`text-2xl font-semibold mb-6 ${
                    darkMode ? 'text-cyan-400' : 'text-cyan-600'
                }`}>
                    {t('notFound.title')}
                </h2>

                <p className={`mb-8 ${
                    darkMode ? 'text-gray-300' : 'text-gray-600'
                }`}>
                    {t('notFound.message')}
                </p>

                <a
                    href="/"
                    className={`flex items-center justify-center mx-auto py-2 px-6 rounded-full font-medium shadow-md transition-all transform hover:scale-105 ${
                        darkMode
                            ? 'bg-cyan-600 hover:bg-cyan-500 text-white'
                            : 'bg-cyan-500 hover:bg-cyan-600 text-white'
                    }`}
                >
                    <FaHome className="mr-2" />
                    {t('notFound.backToHome')}
                </a>
            </motion.div>
        </div>
    );
};

export default NotFound;